var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsBoolean, IsDateString, IsEnum, IsNumber, IsOptional, IsString, IsUUID, } from 'class-validator';
import { StripeAccountStatus } from '../enum/stripe-account-status.enum.js';
import { TaxStatus } from '../enum/tax-status.enum.js';
export class ConnectedStripeAccountResponseDto {
    id;
    createdAt;
    updatedAt;
    stripeAccountId;
    status;
    idVerified;
    officeId;
    demoProductsCreated;
    name;
    taxStatus;
    stripeTaxRateId;
    stripeTaxId;
    applicationFeePercentage;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ConnectedStripeAccountResponseDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], ConnectedStripeAccountResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], ConnectedStripeAccountResponseDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], ConnectedStripeAccountResponseDto.prototype, "stripeAccountId", void 0);
__decorate([
    IsEnum(StripeAccountStatus),
    Expose(),
    __metadata("design:type", String)
], ConnectedStripeAccountResponseDto.prototype, "status", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], ConnectedStripeAccountResponseDto.prototype, "idVerified", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ConnectedStripeAccountResponseDto.prototype, "officeId", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], ConnectedStripeAccountResponseDto.prototype, "demoProductsCreated", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ConnectedStripeAccountResponseDto.prototype, "name", void 0);
__decorate([
    IsEnum(TaxStatus),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], ConnectedStripeAccountResponseDto.prototype, "taxStatus", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ConnectedStripeAccountResponseDto.prototype, "stripeTaxRateId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ConnectedStripeAccountResponseDto.prototype, "stripeTaxId", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ConnectedStripeAccountResponseDto.prototype, "applicationFeePercentage", void 0);
//# sourceMappingURL=connected-stripe-account.response.dto.js.map